module.exports = __webpack_public_path__ + "img/yahoo.df6285f5.png";